import React from 'react';

import { useAppSelector } from 'segments/hooks';

import { Role, selectUserRole } from 'features/user';

import DashboardAdmin from './components/DashboardAdmin';
import DashboardCoach from './components/DashboardCoach';
import DashboardModals from './components/DashboardModals';

const selectDashboard = (role: Role | null) => {
  switch (role) {
    case 'admin':
    case 'operator':
    case 'organization':
      return <DashboardAdmin />;
    case 'coach':
      return <DashboardCoach />;
    default:
      return null;
  }
};

const Dashboard = () => {
  const role = useAppSelector(selectUserRole);
  return (
    <>
      {selectDashboard(role)}
      <DashboardModals />
    </>
  );
};

export default Dashboard;

